import { PeliasService } from "../children/autocomplete/hooks/usePeliasPlaces";

type getPeliasCoordinatesProps = {
  peliasService: PeliasService | null;
  placeId: string | null;
  latitude: string | undefined;
  longitude: string | undefined;
};

export type PlaceCoordinates = {
  computedLatitude: number;
  computedLongitude: number;
};

export const getPeliasCoordinates = async ({
  peliasService,
  placeId,
  latitude,
  longitude,
}: getPeliasCoordinatesProps): Promise<PlaceCoordinates> => {
  // For Pelias, coordinates are already available in latitude/longitude params
  // No need to call getPeliasPlaceDetails since coordinates are stored directly
  if (
    latitude !== undefined &&
    longitude !== undefined &&
    latitude !== "" &&
    longitude !== ""
  ) {
    return {
      computedLatitude: parseFloat(latitude),
      computedLongitude: parseFloat(longitude),
    };
  }

  // Fallback to place details if coordinates not available
  if (peliasService !== null && placeId !== null) {
    const placeDetails = await peliasService.getPeliasPlaceDetails(placeId);

    return {
      computedLatitude: placeDetails?.latitude ?? 0,
      computedLongitude: placeDetails?.longitude ?? 0,
    };
  }

  // Default fallback
  return {
    computedLatitude: 0,
    computedLongitude: 0,
  };
};
